import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import FlagIcon from '@atlaskit/icon/core/flag';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.flag-field.icon-label',
		defaultMessage: 'Flag field icon',
		description:
			'Accessibility label (aria-label) for a flag icon displayed in the Jira work item fields update action card within the AI conversation interface, representing a flag field that will be updated. Shown as a screen reader announcement when the icon is focused or hovered. The purpose is to provide accessible information about the field type icon for users with assistive technologies, indicating that this field is a flag field.',
	},
});

export function FlagFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<FlagIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
